import { RoomNote } from "@/core/api/room.note.api"

export default {
  saveNote: async ({ dispatch, commit, getters, rootGetters }, params) => {
    return await RoomNote.saveNote(params);
  },
  editNote: async ({ dispatch, commit, getters, rootGetters }, params) => {
    return await RoomNote.editNote(params);
  },
  getNotes: async ({ dispatch, commit, getters, rootGetters }) => {
    return await RoomNote.getNotes();
  },
  getNote: async ({ dispatch, commit, getters, rootGetters }) => {
    return await RoomNote.getNote();
  },
};
